import { ofType } from 'redux-observable';
import { mergeMap, map, filter } from 'rxjs';
import { AppEpic, AppState } from 'src/store';
import { of } from 'rxjs';
import { inputIsNotNullOrUndefined, isScopeDefined, topMemInUrl } from 'src/utils/Functions/epicsFunctions';
import { get, isEmpty } from 'lodash';
import {
  ConfDefnComponentType,
  EditableOverTimeGridComponent,
  maybeGetComponentProps,
  isWorklistActive,
} from 'src/services/configuration/codecs/confdefnComponents';
import {
  fetchOverTimeData,
  updateSelectedItem,
  refreshOvertimeData,
  fetchCompanionData,
} from 'src/pages/AssortmentBuild/FlowSheet/FlowSheetByStyle.slice';

import { updateSelectedItem as worklistUpdateSelectedItem } from 'src/pages/Worklist/Worklist.slice';
import { completeItemUndo } from 'src/pages/AssortmentBuild/Planning.slice';
import { receiveScopeRefreshTrigger } from 'src/components/AssortmentScopeSelector/AssortmentScopeSelector.slice';
import { receiveFilterStateAfterSubmission } from 'src/components/FilterPanel/FilterPanel.slice';

function fetchTopMember(state: AppState, worklistSelectedItem?: string): string {
  const flowSheetSelectedItem = !isEmpty(state.pages.assortmentBuild.flowSheet.selectedItem)
    ? state.pages.assortmentBuild.flowSheet.selectedItem
    : null;
  const worklistItem = worklistSelectedItem;
  const urlTopMember = topMemInUrl();
  return flowSheetSelectedItem ?? worklistItem ?? urlTopMember ?? '';
}

export const flowSheetByStyleOvertimeLoad: AppEpic = (action$, state$) => {
  return action$.pipe(
    ofType(updateSelectedItem.type, refreshOvertimeData.type, completeItemUndo.type, worklistUpdateSelectedItem.type),
    map(() => maybeGetComponentProps<EditableOverTimeGridComponent>(state$.value, ConfDefnComponentType.flowSheet)),
    filter(inputIsNotNullOrUndefined),
    filter(() => isScopeDefined(state$.value.scope)),
    mergeMap(({ dataApi, topMembers, defns }) => {
      const worklistSelectedItem = topMembers;
      const currentSelectedItem = fetchTopMember(state$.value, worklistSelectedItem);

      // we allow a third element to be passed in from `componentProps.defns.models` in flowsheet/pricing,
      // to override the modeldefn, in order to support different pivot runs
      const maybeThirdModel = defns && defns.models ? get(defns.models, '2', undefined) : undefined;

      if (!isEmpty(currentSelectedItem)) {
        return of(fetchOverTimeData(currentSelectedItem, dataApi, maybeThirdModel));
      }

      return of();
    }),
  );
};

// NOTE: The below epic is only used when not in a worklist
export const flowSheetByStyleCompanionLoad: AppEpic = (action$, state$) => {
  return action$.pipe(
    ofType(receiveScopeRefreshTrigger.type, 'LENS_ASST_PLAN_REFRESHING_PAGE', receiveFilterStateAfterSubmission.type),
    map(() => maybeGetComponentProps<EditableOverTimeGridComponent>(state$.value, ConfDefnComponentType.flowSheet)),
    filter(inputIsNotNullOrUndefined),
    filter(() => !isWorklistActive(state$.value)),
    filter(() => isScopeDefined(state$.value.scope)),
    mergeMap(({ defns }) => {
      const hideCompanion = maybeGetComponentProps<EditableOverTimeGridComponent>(
        state$.value,
        ConfDefnComponentType.flowSheet,
      )?.hideCompanion;
      if (hideCompanion === true) {
        return of(updateSelectedItem(''));
      }
      return of(updateSelectedItem(''), fetchCompanionData(defns.models));
    }),
  );
};
